class CustomAccordion extends HTMLElement {
    constructor() {
        super();

        this.selectors = {
            accordionRow: '.accordion_item',
            accordionTrigger: '.accordion-heading',
            accordionContentWrapper: '.accordion-more',
            accordionContent: '.accordion-more div',
        }

        this.accordionRows = this.querySelectorAll(this.selectors.accordionRow);
        this.accordionTrigger = this.querySelectorAll(this.selectors.accordionRow);
    }

    toggleAccordion(event) {
        const target_row = event.target.closest(this.selectors.accordionRow);
        if (target_row.classList.contains('active')) {
            this.close(target_row);
        } else {
            this.open(target_row);
        }
    }

    open(row) {
        if (this.dataset.allowMultipleOpen == 'false') this.accordionRows.forEach(r => this.close(r));
        row.classList.add('active');
        const row_wrapper = row.querySelector(this.selectors.accordionContentWrapper);
        const row_content = row.querySelector(this.selectors.accordionContent);

        row_wrapper.style.setProperty('height', row_content.offsetHeight + "px");
        row_wrapper.style.setProperty('opacity', 1);
        row_wrapper.classList.add('item-margin-top');
    }

    close(row) {
        row.classList.remove('active');
        const row_wrapper = row.querySelector(this.selectors.accordionContentWrapper);
        row_wrapper.style.removeProperty('height');
        row_wrapper.style.setProperty('opacity', 0);
        row_wrapper.classList.remove('item-margin-top');
    }

    connectedCallback() {
        this.accordionTrigger.forEach((trigger, index) => {
            trigger.addEventListener('click', this.toggleAccordion.bind(this));
            if (trigger.dataset.initialOpenedIndex && trigger.dataset.initialOpenedIndex == index) {
                trigger.click();
            }
        });
    }

    disconnectedCallback() {
        this.accordionTrigger.forEach(trigger => {
            trigger.removeEventListener('click', this.toggleAccordion);
        });
    }
}

if (!window.customElements.get("custonm-accordion")) {
    window.customElements.define("custom-accordion", CustomAccordion);
}